export default __webpack_public_path__ + "static/media/image8tum.63fec21b.jpg";